import { z } from "zod/v4";
import { defineResource, defineEndpoint } from "@visioni/a3s-client-api";
import { FEATURE_NAME } from "../constants";

export const MyPermissionsResponse = z.object({
  serializedPermissions: z.string(),
  userId: z.string(),
  tenantId: z.string(),
});
export type MyPermissionsResponse = z.infer<typeof MyPermissionsResponse>;

export const myPermissionsResource = defineResource({
  feature: FEATURE_NAME,
  resource: "me",
  scope: "tenant",
});

export const myPermissionsEndpoint = defineEndpoint(myPermissionsResource, {
  responseSchema: MyPermissionsResponse,
});
